import { Accordion } from 'flowbite-react';
const AiStrategyFAQ: React.FC = () => {
    return (
        <>
            <Accordion>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                         How do you assess our organization&apos;s AI readiness?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            We evaluate your AI readiness across strategy, data, technology, talent, and governance using proven AI maturity models and custom scorecards to identify strengths, gaps, and roadmap priorities. This comprehensive assessment ensures aligned capabilities for deploying AI successfully.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                       What&apos;s included in an AI strategy engagement?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           An AI strategy engagement includes assessing current capabilities, identifying high-impact use cases, developing a tailored AI roadmap, conducting ROI analysis, evaluating technology evaluation, pilot planning, change management, and ongoing advisory support to deliver measurable business value.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How long does it take to develop an AI roadmap?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           The timeline typically ranges from 6 to 12 weeks, depending on organizational complexity and scope, enabling thorough discovery, maturity assessment, use case prioritization, strategy creation, and alignment with business KPIs.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do you prioritize which AI use cases to pursue first?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            We prioritize use cases based on impact, feasibility, strategic alignment, and ROI potential, balancing quick wins with transformational projects to maximize business value and accelerate AI adoption.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                       Can you help us evaluate AI vendors and technologies?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Yes, we leverage industry reports, benchmarks, and build-vs-buy analyses to assess AI vendors and technology platforms, ensuring fit-for-purpose, scalability, and cost-effectiveness aligned with your strategic goals.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What if we don&apos;t have clean data or AI expertise?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            We support data readiness initiatives, including profiling, cleansing, and governance, while offering capability building and partner ecosystem connections to bridge AI talent gaps and accelerate readiness.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                       How do you calculate ROI for AI initiatives?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           ROI calculations involve detailed cost-benefit modeling, including investment, operational costs, risk factors, and quantifiable business benefits, using scenario analysis and financial tools to estimate returns and payback periods.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Do you provide implementation support or just strategy?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Beyond strategy, we offer implementation planning, pilot design, change management, and ongoing advisory services to ensure practical execution and successful AI integration.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do you ensure our AI strategy aligns with business goals?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            We align AI strategy through stakeholder engagement, strategic frameworks, and success metrics tied to key business objectives, ensuring AI initiatives drive measurable outcomes and competitive advantage.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What&apos;s the typical investment for AI strategy consulting?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Consulting investments vary by scope and complexity, typically ranging from tens to hundreds of thousands USD, based on assessment depth, roadmap detail, and support level, tailored to deliver clear ROI.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
            </Accordion>
        </>
    );
};

export default AiStrategyFAQ;
